// DOM Elements
const form = document.getElementById('leadForm');
const submitBtn = document.getElementById('submitBtn');
const consentCheckbox = document.getElementById('consent');
const calendarDates = document.getElementById('calendarDates');
const monthSelect = document.getElementById('month');
const yearSelect = document.getElementById('year');

let selectedDate = null;

function getErrorElement(fieldId) {
  // normal case: name-error, mobile-error, etc.
  let el = document.getElementById(`${fieldId}-error`);

  // fallback for your older time slot id
  if (!el && fieldId === "timeSlot") {
    el = document.getElementById("timeslot-error") || document.getElementById("timeSlot-error");
  }

  return el;
}


document.addEventListener('DOMContentLoaded', function () {
    setupEventListeners();
    initializeConcernCollapsible();
    populateUTMParameters();

    // ✅ ALWAYS keep submit active
    submitBtn.disabled = false;
    submitBtn.removeAttribute("disabled");

    // Set the default month to January (0-indexed) and year to 2026
    const now = new Date();
    monthSelect.value = now.getMonth();
    yearSelect.value = now.getFullYear();



    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    selectedDate = tomorrow;

    renderCalendar();
    document.getElementById('appointmentDate').value = formatDate(tomorrow);
    updateTimeSlotsForSelectedDate();
});



function setupEventListeners() {
    // ⬇️ REMOVED 'location' FROM mandatoryFields
    const mandatoryFields = ['name', 'mobile', 'city', 'pincode' ,'address' ,'concern'];
    mandatoryFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.addEventListener('input', function() {
                const errorElement = document.getElementById(`${fieldId}-error`);
                if (errorElement) {
                    errorElement.style.display = 'none';
                    errorElement.classList.remove('show');
                }
                if (this.classList.contains('error')) {
                    this.classList.remove('error');
                }
                validateForm();
            });
            field.addEventListener('blur', function() {
                validateField(fieldId, true);
            });
        }
    });

    //checkbox validation
    consentCheckbox.addEventListener('change', function() {
        const errorElement = document.getElementById('consent-error');
        if (errorElement && this.checked) {
            errorElement.style.display = 'none';
            errorElement.classList.remove('show');
        }
        validateForm();
    });

    // Form submission - just validate before submitting
    form.addEventListener('submit', handleFormSubmit);

    // Calendar changes
    monthSelect.addEventListener('change', renderCalendar);
    yearSelect.addEventListener('change', renderCalendar);

    // Mobile number validation
    const mobileInput = document.getElementById('mobile');
    mobileInput.addEventListener('input', function(e) {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length > 10) {
            this.value = this.value.slice(0, 10);
        }
        const errorElement = document.getElementById('mobile-error');
        if (errorElement) {
            errorElement.style.display = 'none';
            errorElement.classList.remove('show');
        }
        if (this.classList.contains('error')) {
            this.classList.remove('error');
        }
        validateForm();
    });

    // Pincode validation
    const pincodeInput = document.getElementById('pincode');
    pincodeInput.addEventListener('input', function(e) {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length > 6) {
            this.value = this.value.slice(0, 6);
        }
        const errorElement = document.getElementById('pincode-error');
        if (errorElement) {
            errorElement.style.display = 'none';
            errorElement.classList.remove('show');
        }
        if (this.classList.contains('error')) {
            this.classList.remove('error');
        }
        validateForm();
    });

    // City dropdown validation
    const cityDropdown = document.getElementById('city');
    const cityErrorElement = document.getElementById('city-error');
    cityDropdown.addEventListener('change', function() {
        // Hide error if city is selected
        if (this.value !== "") {
            cityErrorElement.style.display = 'none';
            cityErrorElement.classList.remove('show');
            cityDropdown.classList.remove('error');
        } else {
            cityErrorElement.style.display = 'block';
            cityErrorElement.classList.add('show');
            cityDropdown.classList.add('error');
        }
        validateForm();
    });

    // Address input validation
    const addressInput = document.getElementById('address');
    const addressErrorElement = document.getElementById('address-error');
    addressInput.addEventListener('input', function() {
        // If address is empty, show error and add error class
        if (this.value.trim() === "") {
            addressErrorElement.style.display = 'block';
            addressErrorElement.classList.add('show');
            addressInput.classList.add('error');
        } else {
            addressErrorElement.style.display = 'none';
            addressErrorElement.classList.remove('show');
            addressInput.classList.remove('error');
        }
        validateForm();
    });

    // Location picker (safe even if button is removed)
    const locationBtn = document.querySelector('.location-small-btn');
    if (locationBtn) {
        locationBtn.addEventListener('click', getLocation);
    }

    // Concern checkboxes
    const concernCheckboxes = document.querySelectorAll('input[name="concern"]');
    concernCheckboxes.forEach(cb => {
    cb.addEventListener('change', function () {
        this.parentElement.classList.toggle('checked', this.checked);

        const anyChecked = document.querySelectorAll('input[name="concern"]:checked').length > 0;
        const err = document.getElementById('concern-error');

        if (anyChecked && err) {
        err.style.display = 'none';
        err.classList.remove('show');
        }
    });
    });


    // Time slots
    const timeSlots = document.querySelectorAll(".time-slot");
    timeSlots.forEach(slot => {
    slot.addEventListener("click", function () {
        timeSlots.forEach(s => s.classList.remove("selected"));
        this.classList.add("selected");

        const radio = this.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        const err = document.getElementById("timeSlot-error") || document.getElementById("timeslot-error");
        if (err) {
        err.style.display = "none";
        err.classList.remove("show");
        }
    });
    });



}

function validateField(fieldId, showError = false) {
  let isValid = true;
  let errorMsg = "";

  const inputElement = document.getElementById(fieldId);

  // helper to show/hide any error element safely
  function showErr(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.style.display = "block";
    el.classList.add("show");
  }
  function hideErr(el) {
    if (!el) return;
    el.style.display = "none";
    el.classList.remove("show");
  }

  switch (fieldId) {
    case "name": {
      const name = inputElement.value.trim();
      if (!name) {
        isValid = false;
        errorMsg = "Please enter your name";
      }
      if (showError) {
        const err = document.getElementById("name-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
        inputElement.classList.toggle("error", !isValid);
      }
      break;
    }

    case "mobile": {
      const mobile = inputElement.value.trim();
      if (!mobile || mobile.length !== 10 || !/^[0-9]{10}$/.test(mobile)) {
        isValid = false;
        errorMsg = "Enter a valid 10-digit mobile number";
      }
      if (showError) {
        const err = document.getElementById("mobile-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
        inputElement.classList.toggle("error", !isValid);
      }
      break;
    }

    case "pincode": {
      const pincode = inputElement.value.trim();
      if (!pincode || pincode.length !== 6 || !/^[0-9]{6}$/.test(pincode)) {
        isValid = false;
        errorMsg = "Please enter a valid 6-digit pincode";
      }
      if (showError) {
        const err = document.getElementById("pincode-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
        inputElement.classList.toggle("error", !isValid);
      }
      break;
    }

    case "city": {
      const city = inputElement.value.trim();
      if (!city) {
        isValid = false;
        errorMsg = "Please select your city";
      }
      if (showError) {
        const err = document.getElementById("city-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
        inputElement.classList.toggle("error", !isValid);
      }
      break;
    }

    case "address": {
      const address = inputElement.value.trim();
      if (!address) {
        isValid = false;
        errorMsg = "Please enter your address";
      }
      if (showError) {
        const err = document.getElementById("address-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
        inputElement.classList.toggle("error", !isValid);
      }
      break;
    }

    // ✅ HARD FIX: Concern (checkbox group, no inputElement)
    case "concern": {
      const anyChecked =
        document.querySelectorAll('input[name="concern"]:checked').length > 0;

      if (!anyChecked) {
        isValid = false;
        errorMsg = "Please select at least one concern";
      }

      if (showError) {
        const err = document.getElementById("concern-error");
        const concernBody = document.querySelector(".concern-body");
        const arrow = document.querySelector(".arrow");

        // Force-open the concern section so error is visible
        if (!isValid && concernBody) {
          concernBody.style.display = "block";
          if (arrow) arrow.textContent = "▲";
        }

        isValid ? hideErr(err) : showErr(err, errorMsg);
      }
      break;
    }

    case "date": {
      if (!selectedDate) {
        isValid = false;
        errorMsg = "Please select a date";
      }
      if (showError) {
        const err = document.getElementById("date-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
      }
      break;
    }

    // ✅ HARD FIX: TimeSlot (support both ids)
    case "timeSlot": {
    const slotChecked = document.querySelector('input[name="timeSlot"]:checked');
    if (!slotChecked) {
        isValid = false;
        errorMsg = "Please select a time slot";
    }

    if (showError) {
        const err = document.getElementById("timeSlot-error");
        if (!isValid) {
        err.style.display = "block";
        err.classList.add("show");
        err.textContent = errorMsg;
        document.querySelector(".time-slot-section")?.classList.add("has-error");
        } else {
        err.style.display = "none";
        err.classList.remove("show");
        document.querySelector(".time-slot-section")?.classList.remove("has-error");
        }
    }
    break;
    }


    case "consent": {
      if (!consentCheckbox.checked) {
        isValid = false;
        errorMsg = "Please accept the consent to proceed";
      }
      if (showError) {
        const err = document.getElementById("consent-error");
        isValid ? hideErr(err) : showErr(err, errorMsg);
      }
      break;
    }
  }

  return isValid;
}


function validateForm() {
  const isNameValid = document.getElementById('name').value.trim() !== '';
  const isMobileValid = document.getElementById('mobile').value.trim().length === 10;
  const isCityValid = document.getElementById('city').value.trim() !== '';
  const isPincodeValid = document.getElementById('pincode').value.trim().length === 6;
  const isAddressValid = document.getElementById('address').value.trim() !== '';

  const isConcernValid = document.querySelectorAll('input[name="concern"]:checked').length > 0;
  const isDateValid = selectedDate !== null;
  const isTimeSlotValid = document.querySelector('input[name="timeSlot"]:checked') !== null;
  const isConsentValid = consentCheckbox.checked;

  return (
    isNameValid &&
    isMobileValid &&
    isCityValid &&
    isPincodeValid &&
    isAddressValid &&
    isConcernValid &&
    isDateValid &&
    isTimeSlotValid &&
    isConsentValid
  );
}


function initializeConcernCollapsible() {
    const header = document.querySelector(".concern-header");
    const body = document.querySelector(".concern-body");
    const arrow = document.querySelector(".arrow");

    if (!header || !body || !arrow) return;

    let isOpen = true;

    header.addEventListener("click", function () {
        isOpen = !isOpen;
        body.style.display = isOpen ? "block" : "none";
        arrow.textContent = isOpen ? "▲" : "▼";
    });
}

function initializeCalendar() {
    // monthSelect.value = 10;
    // yearSelect.value = 2025;
}

function renderCalendar() {
  const month = parseInt(monthSelect.value);
  const year = parseInt(yearSelect.value);

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const prevLastDay = new Date(year, month, 0);

  const firstDayIndex = firstDay.getDay();
  const lastDayIndex = lastDay.getDay();
  const nextDays = 7 - lastDayIndex - 1;

  let dates = "";

  // Previous month filler
  for (let x = firstDayIndex; x > 0; x--) {
    dates += `<div class="calendar-date other-month disabled">${prevLastDay.getDate() - x + 1}</div>`;
  }

  // ✅ allow ONLY next 7 days starting tomorrow
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const minDate = new Date(today);
  minDate.setDate(today.getDate() + 1); // tomorrow
  minDate.setHours(0, 0, 0, 0);

  const maxDate = new Date(minDate);
  maxDate.setDate(minDate.getDate() + 6); // total 7 days window
  maxDate.setHours(23, 59, 59, 999);

  // Current month dates
  for (let i = 1; i <= lastDay.getDate(); i++) {
    const currentDate = new Date(year, month, i);
    currentDate.setHours(0, 0, 0, 0);

    const isSelected =
      selectedDate &&
      selectedDate.getDate() === i &&
      selectedDate.getMonth() === month &&
      selectedDate.getFullYear() === year;

    const isInRange = currentDate >= minDate && currentDate <= maxDate;

    const className = `calendar-date ${isSelected ? "selected" : ""} ${
      isInRange ? "" : "disabled"
    }`;

    dates += `<div class="${className}" data-date="${i}" data-month="${month}" data-year="${year}">${i}</div>`;
  }

  // Next month filler
  for (let j = 1; j <= nextDays; j++) {
    dates += `<div class="calendar-date other-month disabled">${j}</div>`;
  }

  calendarDates.innerHTML = dates;

  // Click only enabled dates
  document.querySelectorAll(".calendar-date:not(.disabled)").forEach((dateEl) => {
    dateEl.addEventListener("click", function () {
      document.querySelectorAll(".calendar-date").forEach((d) =>
        d.classList.remove("selected")
      );
      this.classList.add("selected");

      const day = parseInt(this.dataset.date);
      const m = parseInt(this.dataset.month);
      const y = parseInt(this.dataset.year);

      selectedDate = new Date(y, m, day);

      document.getElementById("appointmentDate").value = formatDate(selectedDate);
      updateTimeSlotsForSelectedDate();
      document.getElementById("date-error").style.display = "none";

      validateForm();
    });
  });

  // If selectedDate is outside allowed range, reset to tomorrow
  if (!selectedDate || selectedDate < minDate || selectedDate > maxDate) {
    selectedDate = new Date(minDate);
    document.getElementById("appointmentDate").value = formatDate(selectedDate);
    renderCalendar(); // re-render to apply selected class
  }
}



function getLocation(e) {
    e.preventDefault();

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;

            // This will only run if you bring back #location in HTML
            const locInput = document.getElementById('location');
            if (locInput) {
                locInput.value = `${lat}, ${lon}`;
            }

        }, () => {
            alert('Unable to get location. Please enter manually.');
        });
    } else {
        alert('Geolocation not supported.');
    }
}

async function handleFormSubmit(e) {
  e.preventDefault();

  const fieldsToValidate = [
    "name",
    "mobile",
    "pincode",
    "city",
    "address",
    "concern",
    "date",
    "timeSlot",
    "consent",
  ];

  let firstInvalid = null;

  for (let i = 0; i < fieldsToValidate.length; i++) {
    const id = fieldsToValidate[i];
    const ok = validateField(id, true);

    if (!ok) {
      firstInvalid = id;

      // hide all errors AFTER first invalid
      for (let j = i + 1; j < fieldsToValidate.length; j++) {
        const nextId = fieldsToValidate[j];

        const err =
          document.getElementById(`${nextId}-error`) ||
          (nextId === "timeSlot"
            ? document.getElementById("timeslot-error")
            : null);

        if (err) {
          err.style.display = "none";
          err.classList.remove("show");
        }

        // remove highlight class
        if (nextId === "timeSlot") {
          const sec = document.querySelector(".time-slot-section");
          if (sec) sec.classList.remove("has-error");
        }
      }

      break;
    }
  }

  if (firstInvalid) {
    let scrollTarget = null;

    if (firstInvalid === "concern") {
      scrollTarget = document.querySelector(".concern-box");
    } else if (firstInvalid === "timeSlot") {
      scrollTarget = document.querySelector(".time-slot-section");
    } else if (firstInvalid === "date") {
      scrollTarget = document.querySelector(".calendar-section");
    } else {
      scrollTarget = document.getElementById(firstInvalid);
    }

    if (scrollTarget) {
      scrollTarget.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    return false;
  }

  // ✅ all valid → your success flow continues here
  if (selectedDate) {
    document.getElementById("appointmentDate").value = formatDate(selectedDate);
  }

  const name = document.getElementById("name").value;
  const appointmentDate = document.getElementById("appointmentDate").value;
  const timeSlot =
    document.querySelector('input[name="timeSlot"]:checked')?.value || "";

  if (name) document.getElementById("thankYouUserName").textContent = ", " + name;
  if (appointmentDate)
    document.getElementById("thankYouAppointmentDate").textContent = appointmentDate;
  if (timeSlot)
    document.getElementById("thankYouAppointmentTime").textContent = timeSlot;

  document.querySelector(".form-section").style.display = "none";
  document.getElementById("thankYouPage").classList.add("active");
  window.scrollTo({ top: 0, behavior: "smooth" });

  // -----------------------------
  // 1) Submit to Google Sheet (existing)
  // -----------------------------
  const formData = new FormData(form);
  fetch(form.action, { method: "POST", body: formData }).catch(console.error);

  // -----------------------------
  // 2) ALSO send the same data (raw JSON) to QuickReply webhook
  //    + add +91 to phone in payload ONLY
  // -----------------------------
  const QUICKREPLY_WEBHOOK_URL =
    "https://api.quickreply.ai/webhook/company/SjC6JdiRbwWrrTkqB_c/key/aX45YcA4hPCmrpAnj";

  // Convert FormData -> plain object (raw)
  // - If multiple fields share same name, collect into array
  const rawPayload = {};
  for (const [key, value] of formData.entries()) {
    if (rawPayload[key] !== undefined) {
      rawPayload[key] = Array.isArray(rawPayload[key])
        ? [...rawPayload[key], value]
        : [rawPayload[key], value];
    } else {
      rawPayload[key] = value;
    }
  }

  // Ensure QuickReply gets `phone` (map from `mobile` if needed)
  if (rawPayload.mobile && !rawPayload.phone) rawPayload.phone = rawPayload.mobile;

  // Add +91 to phone ONLY for QuickReply payload
  // - strip spaces/dashes
  // - if already starts with +, keep it
  // - if starts with 91XXXXXXXXXX, convert to +91XXXXXXXXXX
  // - if 10-digit, prefix +91
  if (rawPayload.phone) {
    let p = String(rawPayload.phone).trim().replace(/[^\d+]/g, ""); // keep digits and +
    if (p.startsWith("+")) {
      rawPayload.phone = p;
    } else if (p.startsWith("91") && p.length === 12) {
      rawPayload.phone = `+${p}`;
    } else {
      // fallback: assume last 10 digits are the mobile number
      const digits = p.replace(/\D/g, "");
      const last10 = digits.slice(-10);
      rawPayload.phone = last10 ? `+91${last10}` : "";
    }
  }

  fetch(QUICKREPLY_WEBHOOK_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(rawPayload),
  }).catch(console.error);

  // -----------------------------
  // Your existing FB pixel hashing flow (unchanged)
  // -----------------------------
  const nameTrial = document.getElementById("name").value;
  const phoneTrial = document.getElementById("mobile").value;
  const cityTrial = document.getElementById("city").value;
  const pincodeTrial = document.getElementById("pincode").value;

  // Clean the data
  const cleanedName = cleanData(nameTrial);
  const cleanedPhone = cleanData(phoneTrial);
  const cleanedCity = cleanData(cityTrial);
  const cleanedPincode = cleanData(pincodeTrial);

  // Hash the data using SHA-256
  // const hashedName = sha256(cleanedName);
  // const hashedPhone = sha256(cleanedPhone);
  // const hashedCity = sha256(cleanedCity);
  // const hashedPincode = sha256(cleanedPincode);


  const [hashedName, hashedPhone, hashedCity, hashedPincode] = await Promise.all([
  sha256(cleanedName),
  sha256(cleanedPhone),
  sha256(cleanedCity),
  sha256(cleanedPincode)
]);

  fbq("track", "StartTrial", {
    value: 0,
    currency: "INR",
    predicted_ltv: 0,
    phone_number: hashedPhone,
    name: hashedName,
    city: hashedCity,
    pin_code: hashedPincode,
  });

  return false;
}


function getNowIST() {
  // IST = UTC + 5:30
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  return new Date(utc + 5.5 * 60 * 60000);
}

function isSameDay(d1, d2) {
  return (
    d1 &&
    d2 &&
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

function getTomorrowLocal() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  t.setDate(t.getDate() + 1);
  return t;
}

function updateTimeSlotsForSelectedDate() {
  const nowIST = getNowIST();
  const istHour = nowIST.getHours();
  const istMin = nowIST.getMinutes();
  const isAfter4PM = (istHour > 16) || (istHour === 16 && istMin >= 0);

  const tomorrow = getTomorrowLocal();
  const selectedIsTomorrow = isSameDay(selectedDate, tomorrow);

  const allRadios = Array.from(document.querySelectorAll('input[name="timeSlot"]'));

  // Define the 4 slots
  const slot_7_10  = allRadios.find(r => r.value === "7AM - 10AM"); // New slot
  const slot_10_1  = allRadios.find(r => r.value === "10AM - 1PM");
  const slot_1_4   = allRadios.find(r => r.value === "1PM - 4PM");
  const slot_4_7   = allRadios.find(r => r.value === "4PM - 7PM");

  // Safety: if markup changes (check for all 4 now)
  if (!slot_7_10 || !slot_10_1 || !slot_1_4 || !slot_4_7) return;

  const onlyEvening = isAfter4PM && selectedIsTomorrow;

  function setSlotVisible(radio, visible) {
    const label = radio.closest(".time-slot");
    if (!label) return;
    label.style.display = visible ? "" : "none";
    radio.disabled = !visible;
    if (!visible) radio.checked = false;
  }

  if (onlyEvening) {
    // Hide all morning/afternoon slots, show only 4-7
    setSlotVisible(slot_7_10, false);
    setSlotVisible(slot_10_1, false);
    setSlotVisible(slot_1_4, false);
    setSlotVisible(slot_4_7, true);

    // Force select 4-7
    slot_4_7.checked = true;
    document.querySelectorAll(".time-slot").forEach(s => s.classList.remove("selected"));
    slot_4_7.closest(".time-slot")?.classList.add("selected");
  } else {
    // Show all 4 slots
    setSlotVisible(slot_7_10, true);
    setSlotVisible(slot_10_1, true);
    setSlotVisible(slot_1_4, true);
    setSlotVisible(slot_4_7, true);

    // FORCE default to earliest slot (7AM - 10AM) when date is beyond tomorrow
    const isBeyondTomorrow = selectedDate && selectedDate > tomorrow;

    if (isBeyondTomorrow) {
      // Clear selection + force 7-10
      allRadios.forEach(r => (r.checked = false));
      slot_7_10.checked = true;

      document.querySelectorAll(".time-slot").forEach(s => s.classList.remove("selected"));
      slot_7_10.closest(".time-slot")?.classList.add("selected");
    } else {
      // Keep existing choice; if none, default to 7AM - 10AM
      const anyChecked = allRadios.some(r => r.checked && !r.disabled);
      if (!anyChecked) {
        slot_7_10.checked = true;
        document.querySelectorAll(".time-slot").forEach(s => s.classList.remove("selected"));
        slot_7_10.closest(".time-slot")?.classList.add("selected");
      }
    }
  }

  // Clear any previous error once slot becomes valid
  const err = document.getElementById("timeSlot-error") || document.getElementById("timeslot-error");
  if (err) { err.style.display = "none"; err.classList.remove("show"); }
}



function formatDate(date) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                    'July', 'August', 'September', 'October', 'November', 'December'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
}

function populateUTMParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    
    const utmSource = urlParams.get('utm_source') || '';
    const utmMedium = urlParams.get('utm_medium') || '';
    const utmCampaign = urlParams.get('utm_campaign') || '';
    
    document.getElementById('utmSource').value = utmSource;
    document.getElementById('utmMedium').value = utmMedium;
    document.getElementById('utmCampaign').value = utmCampaign;
}


async function copyAndCall(phone) {
  const cleaned = String(phone).trim();
  const telNumber = cleaned.replace(/[^\d+]/g, ""); // keep digits and leading +

  const isMobile = (
    /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    window.matchMedia("(pointer:coarse)").matches
  );

  // --- copy helper with fallback ---
  async function copyText(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {}
    // Fallback for older browsers / non-https
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  }

  const copied = await copyText(cleaned);

  if (isMobile) {
    // Open dialer with number filled
    // (copy happens first; dialer navigation happens right after)
    window.location.href = `tel:${encodeURIComponent(telNumber)}`;
  } else {
    // Desktop feedback
    if (copied) {
      alert(`Phone number copied: ${cleaned}`);
    } else {
      alert(`Couldn't auto-copy. Number is: ${cleaned}`);
    }
  }
}



function initiateWhatsApp() {
    const phoneNumber = '+919289585885';  // Replace with your WhatsApp number
    const message = 'Hello! Help me book home trial.';  // Pre-filled message

    const encodedMessage = encodeURIComponent(message);

    // WhatsApp URL scheme to initiate a chat with pre-filled message (for iOS)
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // WhatsApp Deep Link for iOS devices (this will try to open the WhatsApp app directly)
    const iosWhatsAppURL = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`;

    // Check if the user is on an iOS device
    const isIos = /iphone|ipod|ipad/i.test(navigator.userAgent);

    if (isIos) {
        // For iOS: Try to open using the deep link (whatsapp://)
        const isAppAvailable = checkIfWhatsAppAppAvailable(); // A function to check if WhatsApp app is installed on iOS
        if (isAppAvailable) {
            // Open WhatsApp app directly (iOS only)
            window.location.href = iosWhatsAppURL;
        } else {
            // If WhatsApp isn't installed, fallback to WhatsApp Web (wa.me)
            window.location.href = whatsappURL;
        }
    } else {
        // For Android and Desktop, open using the wa.me URL
        window.open(whatsappURL, '_blank');
    }
}

// Function to detect if WhatsApp is installed on iOS
function checkIfWhatsAppAppAvailable() {
    const iOSWhatsAppLink = 'whatsapp://';
    const appCheck = window.location.href = iOSWhatsAppLink;

    return appCheck === iOSWhatsAppLink;
}

function cleanData(input) {
    return input
        .toLowerCase()                   // Convert to lowercase
        .trim()                           // Remove leading/trailing spaces
        .replace(/[^\w\s]/gi, '');        // Remove punctuation/special characters
}

// SHA-256 hashing function
function sha256(str) {
    const encoder = new TextEncoder(); // Encode string as UTF-8
    const data = encoder.encode(str);  // Convert to bytes
    return crypto.subtle.digest('SHA-256', data)  // Hash the bytes using SHA-256
        .then(hashBuffer => {
            // Convert ArrayBuffer to hexadecimal string
            let hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert buffer to byte array
            let hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join(''); // Convert bytes to hex
            return hashHex;
        });
}

